import { render, staticRenderFns } from "./CreatorDetailCreation.vue?vue&type=template&id=56518ce6&scoped=true&"
import script from "./CreatorDetailCreation.vue?vue&type=script&lang=js&"
export * from "./CreatorDetailCreation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56518ce6",
  null
  
)

export default component.exports